import script from "./CSAE.vue?vue&type=script&setup=true&lang=js"
export * from "./CSAE.vue?vue&type=script&setup=true&lang=js"

import "./CSAE.vue?vue&type=style&index=0&id=56448fa5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56448fa5"]])

export default __exports__